import { WageFrequency } from "@api/shared-runtime/enums";
import {
  WAGE_AMOUNT_PATTERN,
  PAY_WAGE_FREQUENCIES,
  type PayWageFrequency,
} from "@api/shared-runtime/pay-wages";
import type { CustomWage } from "@api/shared-runtime/time-entry-custom-wage";
import { formatCurrency } from "@/features/expense/utils/expense-schema";
import { wageFrequencyToEnding } from "@/features/job-offer/utils/wage-frequency-to-ending";

export { PAY_WAGE_FREQUENCIES };
export type { CustomWage, PayWageFrequency };

export const DEFAULT_CUSTOM_WAGE_FREQUENCY: PayWageFrequency =
  WageFrequency.Hourly;

export const CUSTOM_WAGE_FREQUENCY_LABELS: Record<PayWageFrequency, string> = {
  [WageFrequency.Hourly]: "per hour",
  [WageFrequency.OneTime]: "per shift",
};

export const CUSTOM_WAGE_AMOUNT_ERROR =
  "Enter a dollar amount greater than 0, with up to 2 decimals";

export function isCustomWageFrequency(
  value: unknown,
): value is PayWageFrequency {
  return PAY_WAGE_FREQUENCIES.some((frequency) => frequency === value);
}

/** Matches the server rule: dollars with up to 2 decimals, and above zero. */
export function isValidCustomWageAmount(amount: string): boolean {
  const trimmed = amount.trim();
  return WAGE_AMOUNT_PATTERN.test(trimmed) && Number(trimmed) > 0;
}

/** Formats a wage and frequency as "$525.00/shift" or "$50.00/hr". */
export function formatWage({
  amount,
  wageFrequencyId,
}: {
  amount: string;
  wageFrequencyId: WageFrequency;
}): string {
  return `${formatCurrency(amount)}${wageFrequencyToEnding[wageFrequencyId]}`;
}
